module.exports = __webpack_public_path__ + "static/img/qua.814c7d3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/qua.png
// module id = rF6j
// module chunks = 1